import { makeStyles } from '@material-ui/styles'

const generateTicketStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1.6),
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1.6),
  },
  title: {
    color: theme.palette.common.white,
    marginTop: theme.spacing(1.6),
    marginBottom: theme.spacing(0.8),
  },
  subTitle: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(3.2),
  },
  subTitle2: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(1.6),
  },
}))

export default generateTicketStyles
